import { IDataModel, Model } from '@klickdata/core/application/src/model/model-interface';

export interface OccasionsDatesData extends IDataModel {
    id?: number;
    resource_id?: number;
    start_date?: string;
    end_date?: string;
    enrollment_count?: any;
    total_seats?: number;
    unlimited_seats?: boolean;
}

export class OccasionsDates extends Model<OccasionsDatesData> {
    public id: number;
    public resource_id: number;
    public start_date: string;
    public end_date: string;
    public total_seats: number;
    public approved_seats: number;
    public rejected_count: number;
    public approved_count: number;
    public pending_count: number;
    public waiting_count: number;
    public cancelled_count: number;
    public hasAvailableSeats: boolean;
    public hasValidDate: boolean;
    public isValid: boolean;
    public expired: boolean;
    public canAddEnrollment: boolean;
    public ispassed: boolean;
    public location: string;
    public grib: string;
    public activity: string;
    public other: string;
    public target_group: string;
    public expanded: boolean;
    get enrollment_count(): number {
        return (
            this.rejected_count + this.approved_count + this.cancelled_count + this.pending_count + this.waiting_count
        );
    }
    // public canAddEnrollment(): boolean {
    //     return !this.total_seats || (this.total_seats > 0 && this.total_seats > this.approved_seats);
    // }
}
